import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {link} from "../../host-store";
import {token} from "../../../App";

export const launchAdsApi = createApi({
    reducerPath: "launchAds",
    baseQuery: fetchBaseQuery({
        baseUrl: link
    }),
    tagTypes: ["Advers", "Documents"],
    endpoints: (builder) => ({
        getAdversByStatusActive: builder.query({
            query: () => ({
                url: `/advertisement/user-advertisements?filter[status]=1&pagination=0`,
                headers: {
                    Accept: "application/json",
                    Authorization: token
                }
            }),
            providesTags: ["Advers"]
        }),
        setDocumentsIsApproved: builder.mutation({
            query: ({id, body}) => ({
                url: `/organization/${id}`,
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(body)
            }),
            invalidatesTags: ["Documents"],
        }),
    })
})

export const { useGetAdversByStatusActiveQuery,  useSetDocumentsIsApprovedMutation} = launchAdsApi